import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule, NgbInputDatepicker, NgbTab, NgbTabset } from '@ng-bootstrap/ng-bootstrap';

import { CookieService } from 'ngx-cookie-service';

import { NgxSpinnerModule } from 'ngx-spinner';

import { ScrollToModule } from 'ng2-scroll-to-el';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { JqueryExtensionsService } from "./services/jquery.service";
import { S1DataService } from "./services/s1data.service";
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { AuthService } from './services/auth-service.service';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './components/home/home.component';
import { FeasiblityRequestComponent } from './components/feasibility-request/feasibility-request.component';
import { SampleComponent } from './components/sample/sample.component';
import { SwitchButtonComponent } from './components/switch-button/switch-button.component';
import { CategoryPickerComponent } from './components/category-picker/category-picker.component';
import { QuotaPickerComponent } from './components/quota-picker/quota-picker.component';
import { BidResponseComponent } from './components/feasibility-response/feasibility-response.component';
import { ValidationMessageComponent } from './components/validation-message/validation-message.component';
import { LoginComponent } from './components/login/login.component';
import { QuotaViewerComponent } from './components/quota-viewer/quota-viewer.component';
import { PrettyPrintPipePipe } from './pipes/pretty-print-pipe.pipe';
import { KeysPipe } from "./pipes/keys-pipe.pipe";
import { BlendFilterPipe } from "./pipes/supplier-blend-filter-pipe.pipe";
import { FezaDataService } from './services/fezadata.service';
import { RouteDataService } from './services/routedata.services';
import { NatRepServiceService } from './services/nat-rep-service.service';
import { httpInterceptorProviders } from './interceptors';
import { PanelShareViewerComponent } from './components/panel-share-viewer/panel-share-viewer.component';
import { SettingsPageComponent } from './components/settings-page/settings-page.component';
import { SubsampleComponent } from './components/subsample/subsample.component';
import { BlendViewerComponent } from './components/blend-viewer/blend-viewer.component';
import { ResponseEditComponent } from './components/response-edit/response-edit.component';
import { TargetEditComponent } from './components/target-edit/target-edit.component';
import { EventComponent } from './components/event/event.component';
import { CostViewerComponent } from './components/cost-viewer/cost-viewer.component';
import { FileService } from './services/file.service';
import { AudienceDesignerComponent } from './components/audience-designer/audience-designer.component';
import { ProfileRateComponent } from './components/profile-rate/profile-rate.component';
import { PerformanceComponent } from './components/performance/performance.component';
import { ChartsModule } from 'ng2-charts';
import { RedirectorComponent } from './components/redirector/redirector.component';
import { QuoteSearchComponent } from './components/quote-search/quote-search.component';
import { ReportComponent } from './components/report/report.component';
import { FooterComponent } from './components/footer/footer.component';
import { LogViewerComponent } from './components/log-viewer/log-viewer.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { FeasibilityCountsReportComponent } from './components/feasibility-counts-report/feasibility-counts-report.component';
import { SettingsFileComponent } from './components/settings-file/settings-file.component';
import { NatRepSettingsComponent } from './components/nat-rep-settings/nat-rep-settings.component';
import { S1ResponseComponent } from './components/s1response/s1response.component';
import { QuotaIRService } from './services/genpop-quota-ir.service';
import { MzdTimelineModule } from 'ngx-mzd-timeline';
import { ClipboardModule } from 'ngx-clipboard';
import { QuestionAnswerService } from './services/question-answer-service';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { LoadingService } from './services/loading.service';
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    FeasiblityRequestComponent,
    SampleComponent,
    SwitchButtonComponent,
    CategoryPickerComponent,
    QuotaPickerComponent,
    BidResponseComponent,
    ValidationMessageComponent,
    LoginComponent,
    QuotaViewerComponent,
    PrettyPrintPipePipe,
    PanelShareViewerComponent,
    SettingsPageComponent,
    SubsampleComponent,
    BlendViewerComponent,
    ResponseEditComponent,
    TargetEditComponent,
    KeysPipe,
    EventComponent,
    CostViewerComponent,
    AudienceDesignerComponent,
    ProfileRateComponent,
    BlendFilterPipe,
    PerformanceComponent,
    ReportComponent,
    RedirectorComponent,
    QuoteSearchComponent,
    FooterComponent,
    LogViewerComponent,
    FeasibilityCountsReportComponent,
    SettingsFileComponent,
    NatRepSettingsComponent,
    S1ResponseComponent,
    LoadingSpinnerComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: FeasiblityRequestComponent, canActivate: [AuthGuard] },
      { path: 'request', component: FeasiblityRequestComponent, canActivate: [AuthGuard] },
      { path: 'request/debug', component: FeasiblityRequestComponent, canActivate: [AuthGuard], data: { debug: 1 } },
      { path: 'response/debug', component: BidResponseComponent, canActivate: [AuthGuard], data: { debug: 1 } },
      { path: 'response', component: BidResponseComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 's1response', component: S1ResponseComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'edit', component: ResponseEditComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'subsample', component: SubsampleComponent, canActivate: [AuthGuard] },
      { path: 'event', component: EventComponent, canActivate: [AuthGuard] },
      { path: 'settings', component: SettingsPageComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'help', component: HomeComponent, pathMatch: 'full'},
      { path: 'performance', component: PerformanceComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'report', component: ReportComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'log', component: LogViewerComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'feasibilityCountsReport', component: FeasibilityCountsReportComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'login', component: LoginComponent, pathMatch: 'full' },
      { path: 'logout', component: LoginComponent, pathMatch: 'full' },
    ], { useHash: true }),
    NgbModule.forRoot(),
    NgxSpinnerModule,
    ScrollToModule.forRoot(),
    ChartsModule,
    NgxSmartModalModule.forRoot(),
    NgxDatatableModule,
    MzdTimelineModule,
    ClipboardModule
  ],
  providers: [
    JqueryExtensionsService,
    S1DataService,
    FezaDataService,
    NatRepServiceService,
    QuotaIRService,
    RouteDataService,
    AuthGuard,
    AuthService,
    httpInterceptorProviders,
    CookieService,
    FileService,
    QuestionAnswerService,
    LoadingService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts